import styled from "styled-components";

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ theme, $variant }) => {
    if ($variant === "primary") {
      return `${theme.colors.light?.primary || theme.colors.landing?.accent?.primary || "hsl(258, 90%, 58%)"}20`;
    }
    return theme.colors.light?.muted?.DEFAULT || theme.colors.landing?.background?.secondary || "hsl(240, 10%, 96%)";
  }};
  color: ${({ theme, $variant }) => {
    if ($variant === "primary") {
      return theme.colors.light?.primary || theme.colors.landing?.accent?.primary || "hsl(258, 90%, 58%)";
    }
    return theme.colors.light?.muted?.foreground || theme.colors.landing?.text?.secondary || "hsl(240, 10%, 45%)";
  }};
  border: 1px solid ${({ theme }) => theme.colors.light?.border || theme.colors.landing?.glass?.border || "rgba(255, 255, 255, 0.18)"};
`;

export default Badge;
